import { useApplicationStore } from './aplication-store'
import { ServerMessengerEventData } from './utils/services'

export async function handleOnServerMessagerNotification(events: Array<ServerMessengerEventData>) {
    const appState = useApplicationStore.getState()
    appState.onNotification(events)
}
